// extracted by mini-css-extract-plugin
module.exports = {"bullets":"bullet_bullets__AWi27"};